// Ringtones played by the floating call widget while an inbound call rings.
// Files live in public/audio/dashboard/ringtones/ (CC0, bigsoundbank.com) and
// each includes a trailing silence so looping produces a natural ring cadence.
export const RINGTONES = [
  { value: 'classic', label: 'Classic' },
  { value: 'landline', label: 'Landline' },
  { value: 'office', label: 'Office' },
];

export const DEFAULT_RINGTONE = 'classic';

export const ringtoneUrl = name => `/audio/dashboard/ringtones/${name}.mp3`;
